var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.84303 12.9917L10.0753 14.1667L14.4453 10L10.0753 5.83333L8.84303 7.00833L11.0979 9.16667H2.64648V10.8333H11.0979L8.84303 12.9917ZM16.6302 2.5H4.39445C3.93086 2.5 3.48626 2.67559 3.15845 2.98816C2.83064 3.30072 2.64648 3.72464 2.64648 4.16667V7.5H4.39445V4.16667H16.6302V15.8333H4.39445V12.5H2.64648V15.8333C2.64648 16.2754 2.83064 16.6993 3.15845 17.0118C3.48626 17.3244 3.93086 17.5 4.39445 17.5H16.6302C17.5916 17.5 18.3782 16.75 18.3782 15.8333V4.16667C18.3782 3.25 17.5916 2.5 16.6302 2.5Z",
    fill: "#B4C9F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.85077bd6bcedf45948a9b6a638932c9a.svg";
export { ForwardRef as ReactComponent };